module.exports = __webpack_public_path__ + "static/img/icon_hitem7.c4bd344.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_hitem7.png
// module id = TMwZ
// module chunks = 21